import { DocumentModel, CURRENT_SCHEMA_VERSION, PageSettings, DocumentSection } from '../../core/ast/document.types';
import { CoverTemplateValues } from '../types';
import { createDefaultPageSettings } from '../../core/ast/factory';
import { UNIVERSITY_CONFIG } from '../../config/university.config';

export function getDefaultCoverValues(overrides?: Partial<CoverTemplateValues>): CoverTemplateValues {
  return {
    universityName: UNIVERSITY_CONFIG.name,
    universityShortName: UNIVERSITY_CONFIG.shortName,
    universityAddress: 'A/2 Jahurul Islam Ave, Dhaka 1212',
    departmentName: UNIVERSITY_CONFIG.defaultDepartment,
    logoAssetId: UNIVERSITY_CONFIG.logoPath,
    showLogo: true,
    logoSizePx: 72,
    logoAlignment: 'center',

    documentTypeLabel: 'LAB REPORT',
    title: 'LAB REPORT',
    subtitle: '',
    experimentNumber: '',
    experimentName: '',
    groupNumber: '',

    courseCode: '',
    courseTitle: '',
    sectionOrGroup: '',
    semester: '',
    academicYear: '',

    studentName: '',
    studentId: '',
    studentEmail: '',
    groupMembers: '',

    facultyName: '',
    facultyDesignation: '',
    facultyDepartment: '',
    supervisorName: '',

    dateOfPerformance: '',
    submissionDate: '',
    submissionDisplayMode: 'both',

    accentColor: '#3182ce',
    borderStyle: 'none',
    layoutDensity: 'comfortable',
    ...overrides,
  };
}

export function buildDocumentFromCoverSections(
  values: CoverTemplateValues,
  sections: DocumentSection[],
  pageSettingsOverrides?: Partial<PageSettings>
): DocumentModel {
  const basePageSettings = createDefaultPageSettings();
  const pageSettings: PageSettings = {
    ...basePageSettings,
    ...pageSettingsOverrides,
    showPageNumbers: false, // Cover page should never show page numbers
  };

  const now = new Date().toISOString();

  return {
    schemaVersion: CURRENT_SCHEMA_VERSION,
    metadata: {
      id: `cover-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 6)}`,
      title: values.title || 'Academic Cover Page',
      subtitle: values.subtitle,
      documentType: 'cover_page',
      courseCode: values.courseCode,
      courseTitle: values.courseTitle,
      author: {
        studentName: values.studentName,
        studentId: values.studentId,
        email: values.studentEmail,
        sectionOrGroup: values.sectionOrGroup,
      },
      instructor: {
        instructorName: values.facultyName,
        designation: values.facultyDesignation,
        department: values.facultyDepartment,
      },
      institution: {
        name: values.universityName,
        shortName: values.universityShortName,
        department: values.departmentName,
        logoAssetId: values.showLogo ? values.logoAssetId : undefined,
      },
      createdAt: now,
      modifiedAt: now,
      submissionDate: values.submissionDate,
      version: 1,
    },
    pageSettings,
    sections,
  };
}
